module.exports = __webpack_public_path__ + "img/logo_us.d9902f1f.svg";